/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

// Get role constants
export const GET_ROLES = 'GET_ROLES';
export const ROLE_REQUEST_GET = 'ROLE_REQUEST_GET';
export const ROLE_RESPONSE_GET_SUCCESS = 'ROLE_RESPONSE_GET_SUCCESS';
export const ROLE_RESPONSE_GET_FAIL = 'ROLE_RESPONSE_GET_FAIL';

export const ALL_ROLE_REQUEST_GET = 'ALL_ROLE_REQUEST_GET';
export const ALL_ROLE_RESPONSE_GET_SUCCESS = 'ALL_ROLE_RESPONSE_GET_SUCCESS';
export const ALL_ROLE_RESPONSE_GET_FAIL = 'ALL_ROLE_RESPONSE_GET_FAIL';

// Get role details constants
export const GET_ROLE_DETAILS = 'GET_ROLE_DETAILS';
export const ROLE_DETAILS_REQUEST_GET = 'ROLE_DETAILS_REQUEST_GET';
export const ROLE_DETAILS_RESPONSE_GET_SUCCESS =
	'ROLE_DETAILS_RESPONSE_GET_SUCCESS';
export const ROLE_DETAILS_RESPONSE_GET_FAIL = 'ROLE_DETAILS_RESPONSE_GET_FAIL';

// Get role permissions constants
export const GET_ROLE_PERMISSIONS = 'GET_ROLE_PERMISSIONS';
export const ROLE_PERMISSIONS_REQUEST_GET = 'ROLE_PERMISSIONS_REQUEST_GET';
export const ROLE_PERMISSIONS_RESPONSE_GET_SUCCESS =
	'ROLE_PERMISSIONS_RESPONSE_GET_SUCCESS';
export const ROLE__PERMISSIONS_RESPONSE_GET_FAIL =
	'ROLE__PERMISSIONS_RESPONSE_GET_FAIL';

/**
 * Action types for put role data.
 *
 * These constants represent different stages of the role data deleting process
 */
export const ROLE_REQUEST_PUT = 'ROLE_REQUEST_PUT';
export const ROLE_RESPONSE_PUT_FAIL = 'ROLE_RESPONSE_PUT_FAIL';
export const DELETE_ROLE_RESPONSE_SUCCESS = 'DELETE_ROLE_RESPONSE_SUCCESS';
export const RESET_ROLE_DELETE = 'RESET_ROLE_DELETE';
export const ROLE_DELETED_SUCCESSFULLY = 'ROLE_DELETED_SUCCESSFULLY';
export const ROLE_DELETION_ERROR = 'ERROR_IN_ROLE_DELETION';

export const ROLE_SELECTED = 'ROLE_SELECTED';

/**
 * Action types for post role data.
 *
 * These constants represent different stages of the role data adding process
 */
export const ROLE_REQUEST_ADD = 'ROLE_REQUEST_ADD';
export const ROLE_RESPONSE_ADD_FAIL = 'ROLE_RESPONSE_ADD_FAIL';
export const ROLE_RESPONSE_ADD_SUCCESS = 'ROLE_RESPONSE_ADD_SUCCESS';
export const RESET_ROLE_ADD = 'RESET_ROLE_ADD';
export const ROLE_ADDED_SUCCESFULLY = 'ROLE_CREATED_SUCCESSFULLY';
export const ROLE_ADD_SUCCESS_MESSAGE = 'Role Added Successfully';
export const ROLE_ERROR_MESSAGES = {
	name: 'group with this name already exists.',
};

export const ROLE_REQUEST_EDIT = 'ROLE_REQUEST_EDIT';
export const ROLE_RESPONSE_EDIT_FAIL = 'ROLE_RESPONSE_EDIT_FAIL';
export const ROLE_RESPONSE_EDIT_SUCCESS = 'ROLE_RESPONSE_EDIT_SUCCESS';
export const RESET_ROLE_EDIT = 'RESET_ROLE_EDIT';
export const ROLE_EDITED_SUCCESFULLY = 'ROLE_IS_BEING_UPDATED';
export const ROLE_EDIT_SUCCESS_MESSAGE = 'Role edited Successfully';
